import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors duration-300 uppercase tracking-wider focus:outline-none focus:ring-2 focus:ring-[#DDA247] focus:ring-offset-2 focus:ring-offset-[#0B1014]';
  const variants = {
    primary: 'bg-[#DDA247] text-[#0B1014] hover:bg-white hover:text-[#0B1014]',
    outline: 'border border-white text-white hover:bg-white hover:text-[#0B1014]',
    ghost: 'text-white hover:text-[#DDA247]'
  };
  const sizes = {
    sm: 'text-xs px-4 py-2',
    md: 'text-sm px-6 py-3',
    lg: 'text-base px-8 py-4'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-728">
      {children}
    </motion.button>;
}